import { createFileRoute } from '@tanstack/react-router';

import { hasPermission } from '@nucleus-commerce/admin-kit/permissions';

import { requirePermission } from '@/app/guards';
import {
  PaymentMethodsPage,
  paymentMethodsQueryOptions,
  stripeAccountQueryOptions,
} from '@/features/payment-methods';

export const Route = createFileRoute('/_authed/_active/s/$storeId/settings/payment-methods')({
  staticData: { crumb: 'common:nav.paymentMethods', tours: ['settings.payment-methods'] },
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'payments.manage');
  },
  loader: ({ context, params }) =>
    Promise.all([
      context.queryClient
        .query({ ...paymentMethodsQueryOptions(params.storeId), staleTime: 'static' })
        .catch(() => undefined),
      hasPermission(context.me.permissions, 'settings.read')
        ? context.queryClient
            .query({ ...stripeAccountQueryOptions(params.storeId), staleTime: 'static' })
            .catch(() => undefined)
        : undefined,
    ]),
  component: PaymentMethodsPage,
});
